import { supabase } from '../../lib/supabase';
import { MeetingNotes } from '../../types/meetings';

export const meetingNotesService = {
  async updateField(meetingId: string, userId: string, field: keyof MeetingNotes, value: any) {
    const { error } = await supabase
      .from('meeting_notes')
      .update({
        [field]: value,
        updated_at: new Date().toISOString()
      })
      .eq('meeting_id', meetingId)
      .eq('user_id', userId);

    if (error) throw error;
    return null;
  },

  async getMeetingNotes(meetingId: string, userId: string): Promise<MeetingNotes | null> {
    const { data, error } = await supabase
      .from('meeting_notes')
      .select('*')
      .eq('meeting_id', meetingId)
      .eq('user_id', userId)
      .maybeSingle();

    if (error) throw error;
    return data;
  }
};